
export const PLUGIN_CATEGORIES = [
  { label: 'Broswer', value: 'browser' },
  { label: 'Other', value: 'other' },
  { label: 'Steward', value: 'steward' },
  { label: 'Extension', value: 'extension' },
]